import React, {useEffect, useRef} from 'react';
import {Animated, View, StyleSheet} from 'react-native';
import CCColors from '@/Utils/CCColors';

const DotLoader = () => {
  const dotAnimations = useRef(
    [...Array(4)].map(() => new Animated.Value(0)),
  ).current;

  useEffect(() => {
    const animations = dotAnimations.map((dot, index) => {
      return Animated.loop(
        Animated.sequence([
          Animated.delay(index * 100),
          Animated.timing(dot, {
            toValue: -5,
            duration: 300,
            useNativeDriver: true,
          }),
          Animated.timing(dot, {
            toValue: 0,
            duration: 300,
            useNativeDriver: true,
          }),
        ]),
      );
    });

    Animated.stagger(100, animations).start();
  }, []);

  return (
    <View style={styles.container}>
      {dotAnimations.map((anim, index) => (
        <Animated.View
          key={index}
          style={[
            styles.dot,
            {
              transform: [{translateY: anim}],
            },
          ]}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 5,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 4,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: CCColors?.TextColor?.Dark,
  },
});

export default DotLoader;
